import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function FlexDirection({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        (["row", "column"] as const).map((alignment) => (
          <MenuItem key={alignment} value={alignment}>
            <span style={{ flexDirection: alignment }}>{alignment}</span>
          </MenuItem>
        )),
      ]}
      rules={{ required }}
    />
  );
}

export const JSFlexDirectionComponent: JSInputComponent = {
  Component: FlexDirection,
  handlesCssProperties: ["flexDirection"],
};
